<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    :color="$vuetify.theme.dark ? '' : 'white'"
    flat
    height="75"
    elevation="0"
  >
    <v-btn
      class="mr-3"
      :style="
        $vuetify.theme.dark
          ? 'box-shadow: 0px 0px 3px 0px #dcdcdc54'
          : 'box-shadow: 0px 0px 3px 0px rgba(100,100,100,0.1)'
      "
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value"> mdi-view-quilt </v-icon>
      <v-icon v-else> mdi-dots-vertical </v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light" />
    <v-spacer />
    {{ userMe.name }}
    <v-spacer />
    <div class="mx-3" />
    <languages />
    <download />
    <v-btn icon @click="setMode"> <v-icon>mdi-theme-light-dark</v-icon></v-btn>
    <v-btn icon to="/app/about"> <v-icon>mdi-information</v-icon></v-btn>
    <dataPrivacy />
  </v-app-bar>
</template>

<script>
import { VHover, VListItem } from "vuetify/lib";
import download from "./Download";
import dataPrivacy from "./dataPrivacy.vue";
import languages from "./languagesView.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "appCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text primary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },
  components: { download, languages, dataPrivacy },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({}),
  computed: {
    ...mapState(["darkMode"]),
    ...mapState(["drawer"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },

    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },

  methods: {
    setMode() {
      this.$store.dispatch("changeDarkMode", !this.darkMode);
      this.$vuetify.theme.dark = this.darkMode;
    },
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
};
</script>
